const startEndTimeOptions = {
  endTimeList: [
    { name: '12:14 AM', value: '00:14:59' },
    { name: '12:29 AM', value: '00:29:59' },
    { name: '12:44 AM', value: '00:44:59' },
    { name: '12:59 AM', value: '00:59:59' },
    { name: '1:14 AM', value: '01:14:59' },
    { name: '1:29 AM', value: '01:29:59' },
    { name: '1:44 AM', value: '01:44:59' },
    { name: '1:59 AM', value: '01:59:59' },
    { name: '2:14 AM', value: '02:14:59' },
    { name: '2:29 AM', value: '02:29:59' },
    { name: '2:44 AM', value: '02:44:59' },
    { name: '2:59 AM', value: '02:59:59' },
    { name: '3:14 AM', value: '03:14:59' },
    { name: '3:29 AM', value: '03:29:59' },
    { name: '3:44 AM', value: '03:44:59' },
    { name: '3:59 AM', value: '03:59:59' },
    { name: '4:14 AM', value: '04:14:59' },
    { name: '4:29 AM', value: '04:29:59' },
    { name: '4:44 AM', value: '04:44:59' },
    { name: '4:59 AM', value: '04:59:59' },
    { name: '5:14 AM', value: '05:14:59' },
    { name: '5:29 AM', value: '05:29:59' },
    { name: '5:44 AM', value: '05:44:59' },
    { name: '5:59 AM', value: '05:59:59' },
    { name: '6:14 AM', value: '06:14:59' },
    { name: '6:29 AM', value: '06:29:59' },
    { name: '6:44 AM', value: '06:44:59' },
    { name: '6:59 AM', value: '06:59:59' },
    { name: '7:14 AM', value: '07:14:59' },
    { name: '7:29 AM', value: '07:29:59' },
    { name: '7:44 AM', value: '07:44:59' },
    { name: '7:59 AM', value: '07:59:59' },
    { name: '8:14 AM', value: '08:14:59' },
    { name: '8:29 AM', value: '08:29:59' },
    { name: '8:44 AM', value: '08:44:59' },
    { name: '8:59 AM', value: '08:59:59' },
    { name: '9:14 AM', value: '09:14:59' },
    { name: '9:29 AM', value: '09:29:59' },
    { name: '9:44 AM', value: '09:44:59' },
    { name: '9:59 AM', value: '09:59:59' },
    { name: '10:14 AM', value: '10:14:59' },
    { name: '10:29 AM', value: '10:29:59' },
    { name: '10:44 AM', value: '10:44:59' },
    { name: '10:59 AM', value: '10:59:59' },
    { name: '11:14 AM', value: '11:14:59' },
    { name: '11:29 AM', value: '11:29:59' },
    { name: '11:44 AM', value: '11:44:59' },
    { name: '11:59 AM', value: '11:59:59' },
    { name: '12:14 PM', value: '12:14:59' },
    { name: '12:29 PM', value: '12:29:59' },
    { name: '12:44 PM', value: '12:44:59' },
    { name: '12:59 PM', value: '12:59:59' },
    { name: '1:14 PM', value: '13:14:59' },
    { name: '1:29 PM', value: '13:29:59' },
    { name: '1:44 PM', value: '13:44:59' },
    { name: '1:59 PM', value: '13:59:59' },
    { name: '2:14 PM', value: '14:14:59' },
    { name: '2:29 PM', value: '14:29:59' },
    { name: '2:44 PM', value: '14:44:59' },
    { name: '2:59 PM', value: '14:59:59' },
    { name: '3:14 PM', value: '15:14:59' },
    { name: '3:29 PM', value: '15:29:59' },
    { name: '3:44 PM', value: '15:44:59' },
    { name: '3:59 PM', value: '15:59:59' },
    { name: '4:14 PM', value: '16:14:59' },
    { name: '4:29 PM', value: '16:29:59' },
    { name: '4:44 PM', value: '16:44:59' },
    { name: '4:59 PM', value: '16:59:59' },
    { name: '5:14 PM', value: '17:14:59' },
    { name: '5:29 PM', value: '17:29:59' },
    { name: '5:44 PM', value: '17:44:59' },
    { name: '5:59 PM', value: '17:59:59' },
    { name: '6:14 PM', value: '18:14:59' },
    { name: '6:29 PM', value: '18:29:59' },
    { name: '6:44 PM', value: '18:44:59' },
    { name: '6:59 PM', value: '18:59:59' },
    { name: '7:14 PM', value: '19:14:59' },
    { name: '7:29 PM', value: '19:29:59' },
    { name: '7:44 PM', value: '19:44:59' },
    { name: '7:59 PM', value: '19:59:59' },
    { name: '8:14 PM', value: '20:14:59' },
    { name: '8:29 PM', value: '20:29:59' },
    { name: '8:44 PM', value: '20:44:59' },
    { name: '8:59 PM', value: '20:59:59' },
    { name: '9:14 PM', value: '21:14:59' },
    { name: '9:29 PM', value: '21:29:59' },
    { name: '9:44 PM', value: '21:44:59' },
    { name: '9:59 PM', value: '21:59:59' },
    { name: '10:14 PM', value: '22:14:59' },
    { name: '10:29 PM', value: '22:29:59' },
    { name: '10:44 PM', value: '22:44:59' },
    { name: '10:59 PM', value: '22:59:59' },
    { name: '11:14 PM', value: '23:14:59' },
    { name: '11:29 PM', value: '23:29:59' },
    { name: '11:44 PM', value: '23:44:59' },
    { name: '11:59 PM', value: '23:59:59' },
  ],
  startTimeList: [
    { name: '12:00 AM', value: '00:00:00' },
    { name: '12:15 AM', value: '00:15:00' },
    { name: '12:30 AM', value: '00:30:00' },
    { name: '12:45 AM', value: '00:45:00' },
    { name: '1:00 AM', value: '01:00:00' },
    { name: '1:15 AM', value: '01:15:00' },
    { name: '1:30 AM', value: '01:30:00' },
    { name: '1:45 AM', value: '01:45:00' },
    { name: '2:00 AM', value: '02:00:00' },
    { name: '2:15 AM', value: '02:15:00' },
    { name: '2:30 AM', value: '02:30:00' },
    { name: '2:45 AM', value: '02:45:00' },
    { name: '3:00 AM', value: '03:00:00' },
    { name: '3:15 AM', value: '03:15:00' },
    { name: '3:30 AM', value: '03:30:00' },
    { name: '3:45 AM', value: '03:45:00' },
    { name: '4:00 AM', value: '04:00:00' },
    { name: '4:15 AM', value: '04:15:00' },
    { name: '4:30 AM', value: '04:30:00' },
    { name: '4:45 AM', value: '04:45:00' },
    { name: '5:00 AM', value: '05:00:00' },
    { name: '5:15 AM', value: '05:15:00' },
    { name: '5:30 AM', value: '05:30:00' },
    { name: '5:45 AM', value: '05:45:00' },
    { name: '6:00 AM', value: '06:00:00' },
    { name: '6:15 AM', value: '06:15:00' },
    { name: '6:30 AM', value: '06:30:00' },
    { name: '6:45 AM', value: '06:45:00' },
    { name: '7:00 AM', value: '07:00:00' },
    { name: '7:15 AM', value: '07:15:00' },
    { name: '7:30 AM', value: '07:30:00' },
    { name: '7:45 AM', value: '07:45:00' },
    { name: '8:00 AM', value: '08:00:00' },
    { name: '8:15 AM', value: '08:15:00' },
    { name: '8:30 AM', value: '08:30:00' },
    { name: '8:45 AM', value: '08:45:00' },
    { name: '9:00 AM', value: '09:00:00' },
    { name: '9:15 AM', value: '09:15:00' },
    { name: '9:30 AM', value: '09:30:00' },
    { name: '9:45 AM', value: '09:45:00' },
    { name: '10:00 AM', value: '10:00:00' },
    { name: '10:15 AM', value: '10:15:00' },
    { name: '10:30 AM', value: '10:30:00' },
    { name: '10:45 AM', value: '10:45:00' },
    { name: '11:00 AM', value: '11:00:00' },
    { name: '11:15 AM', value: '11:15:00' },
    { name: '11:30 AM', value: '11:30:00' },
    { name: '11:45 AM', value: '11:45:00' },
    { name: '12:00 PM', value: '12:00:00' },
    { name: '12:15 PM', value: '12:15:00' },
    { name: '12:30 PM', value: '12:30:00' },
    { name: '12:45 PM', value: '12:45:00' },
    { name: '1:00 PM', value: '13:00:00' },
    { name: '1:15 PM', value: '13:15:00' },
    { name: '1:30 PM', value: '13:30:00' },
    { name: '1:45 PM', value: '13:45:00' },
    { name: '2:00 PM', value: '14:00:00' },
    { name: '2:15 PM', value: '14:15:00' },
    { name: '2:30 PM', value: '14:30:00' },
    { name: '2:45 PM', value: '14:45:00' },
    { name: '3:00 PM', value: '15:00:00' },
    { name: '3:15 PM', value: '15:15:00' },
    { name: '3:30 PM', value: '15:30:00' },
    { name: '3:45 PM', value: '15:45:00' },
    { name: '4:00 PM', value: '16:00:00' },
    { name: '4:15 PM', value: '16:15:00' },
    { name: '4:30 PM', value: '16:30:00' },
    { name: '4:45 PM', value: '16:45:00' },
    { name: '5:00 PM', value: '17:00:00' },
    { name: '5:15 PM', value: '17:15:00' },
    { name: '5:30 PM', value: '17:30:00' },
    { name: '5:45 PM', value: '17:45:00' },
    { name: '6:00 PM', value: '18:00:00' },
    { name: '6:15 PM', value: '18:15:00' },
    { name: '6:30 PM', value: '18:30:00' },
    { name: '6:45 PM', value: '18:45:00' },
    { name: '7:00 PM', value: '19:00:00' },
    { name: '7:15 PM', value: '19:15:00' },
    { name: '7:30 PM', value: '19:30:00' },
    { name: '7:45 PM', value: '19:45:00' },
    { name: '8:00 PM', value: '20:00:00' },
    { name: '8:15 PM', value: '20:15:00' },
    { name: '8:30 PM', value: '20:30:00' },
    { name: '8:45 PM', value: '20:45:00' },
    { name: '9:00 PM', value: '21:00:00' },
    { name: '9:15 PM', value: '21:15:00' },
    { name: '9:30 PM', value: '21:30:00' },
    { name: '9:45 PM', value: '21:45:00' },
    { name: '10:00 PM', value: '22:00:00' },
    { name: '10:15 PM', value: '22:15:00' },
    { name: '10:30 PM', value: '22:30:00' },
    { name: '10:45 PM', value: '22:45:00' },
    { name: '11:00 PM', value: '23:00:00' },
    { name: '11:15 PM', value: '23:15:00' },
    { name: '11:30 PM', value: '23:30:00' },
    { name: '11:45 PM', value: '23:45:00' },
  ],
};

const typeList = [
  { id: 1, name: 'Email Message', value: 'email' },
  { id: 4, name: 'SMS Message', value: 'real_sms' },
  { id: 3, name: 'HTTP Post', value: 'http_post' },
  { id: 5, name: 'Push Notification', value: 'push_notification' },
];

const reminderIntervalList = [
  { name: '5 minutes', value: 5 },
  { name: '10 minutes', value: 10 },
  { name: '15 minutes', value: 15 },
  { name: '30 minutes', value: 30 },
  { name: '1 hour', value: 60 },
  { name: '2 hours', value: 120 },
  { name: '6 hours', value: 360 },
  { name: '12 hours', value: 720 },
  { name: '1 day', value: 1440 },
];

const delayIntervalList = [
  { name: '5 minutes', value: 5 },
  { name: '10 minutes', value: 10 },
  { name: '15 minutes', value: 15 },
  { name: '30 minutes', value: 30 },
  { name: '1 hour', value: 60 },
  { name: '2 hours', value: 120 },
  { name: '6 hours', value: 360 },
  { name: '12 hours', value: 720 },
  { name: '1 day', value: 1440 },
  { name: '3 days', value: 4320 },
  { name: '5 days', value: 7200 },
  { name: '7 days', value: 10080 },
];

const daysOfWeek = [
  { name: 'Sunday', value: 0 },
  { name: 'Monday', value: 1 },
  { name: 'Tuesday', value: 2 },
  { name: 'Wednesday', value: 3 },
  { name: 'Thursday', value: 4 },
  { name: 'Friday', value: 5 },
  { name: 'Saturday', value: 6 },
];

const wirelessProviderList = [
  { name: 'AT&T', value: 'txt.att.net' },
  { name: 'Bell Canada', value: 'txt.bell.ca' },
  { name: 'Boost', value: 'myboostmobile.com' },
  { name: 'Metro PCS', value: 'mymetropcs.com' },
  { name: 'MTS Canada', value: 'text.mts.net' },
  { name: 'Republic Wireless', value: 'text.republicwireless.com' },
  // { name: 'Rogers Communications (Canada)', value: 'pcs.rogers.com' },
  { name: 'Sprint PCS', value: 'messaging.sprintpcs.com' },
  { name: 'T-Mobile', value: 'tmomail.net' },
  { name: 'TELUS (Canada)', value: 'msg.telus.com' },
  { name: 'U.S. Cellular', value: 'email.uscc.net' },
  { name: 'Verizon', value: 'vtext.com' },
  { name: 'Virgin Mobile (USA)', value: 'vmobl.com' },
  { name: 'Other', value: 'other' },
];

const defaultQuietTime = {
  dayOfWeek: '0',
  startTime: '00:00:00',
  endTime: '23:59:59',
};

const createObservableQuietTime = (data) => ({
  id: data.id,
  dayOfWeek: data.dayOfWeek,
  startTime: data.startTime,
  endTime: data.endTime,
});

const isEmail = (actionType) => actionType === 'email';
const isEmailToTextMessage = (actionType) => actionType === 'sms';
const isHttpPost = (actionType) => actionType === 'http_post';
const isTextMessage = (actionType) => actionType === 'real_sms';
const isPushNotification = (actionType) => actionType === 'push_notification';

const formatPhoneNumber = (phoneNumber) => (phoneNumber ? phoneNumber.replace(/\D+/g, '')
  .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  : undefined);

export {
  typeList,
  reminderIntervalList,
  delayIntervalList,
  daysOfWeek,
  wirelessProviderList,
  defaultQuietTime,
  isEmail,
  isEmailToTextMessage,
  isHttpPost,
  isTextMessage,
  isPushNotification,
  createObservableQuietTime,
  startEndTimeOptions,
  formatPhoneNumber,
};
